export const A4_WIDTH = 793;
export const A4_HEIGHT = 1123;

export const CANVAS_OUTER_PADDING = 16;

export const PAPER_WIDTH_RATIO = 0.9;

export const PORTRAIT_DISPLAY_SCALE = 1.5;

export const MIN_PAPER_WIDTH = 600;

export const CANVAS_ZOOM_TRANSITION_MS = 300;

export const CANVAS_ZOOM_TRANSITION_EASING = 'ease-in-out';

export const CANVAS_LAYOUT = {
  PAGE_HEIGHT: A4_HEIGHT,
  PAGE_HEIGHT_LANDSCAPE: A4_WIDTH,
  CANVAS_PADDING: 32,
  PAGE_PADDING: 32,
  ELEMENT_SPACING: 6,
  DEFAULT_ELEMENT_HEIGHT: 40,
  BOTTOM_MARGIN: 40,
  TOP_MARGIN: 64,
  HEADER_TO_CONTENT_GAP: 4,
  TABLE_TO_CONTENT_GAP: 30,
} as const;

export const AVAILABLE_HEIGHT =
  CANVAS_LAYOUT.PAGE_HEIGHT - CANVAS_LAYOUT.TOP_MARGIN - CANVAS_LAYOUT.BOTTOM_MARGIN;

export const AUTO_COLLAPSE_GAP_THRESHOLD = 60;

export const FLOATING_BAR_COLLAPSE_MARGIN = 8;
